var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLessons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666504 0.662C0.668029 0.486919 0.755587 0.319345 0.910265 0.195478C1.06494 0.071612 1.27432 0.00139643 1.49317 0H16.5065C16.9632 0 17.3332 0.296667 17.3332 0.662V11.338C17.3316 11.5131 17.2441 11.6807 17.0894 11.8045C16.9347 11.9284 16.7254 11.9986 16.5065 12H1.49317C1.27385 11.9998 1.06358 11.93 0.908578 11.8059C0.753572 11.6817 0.666504 11.5135 0.666504 11.338V0.662ZM2.33317 1.33333V10.6667H15.6665V1.33333H2.33317ZM7.8515 3.61L11.9173 5.778C11.9631 5.80234 12.0006 5.83535 12.0265 5.87408C12.0524 5.91281 12.066 5.95606 12.066 6C12.066 6.04394 12.0524 6.08719 12.0265 6.12592C12.0006 6.16465 11.9631 6.19766 11.9173 6.222L7.85067 8.39C7.80053 8.41659 7.74232 8.43183 7.68223 8.4341C7.62214 8.43637 7.5624 8.42559 7.50934 8.4029C7.45629 8.38021 7.4119 8.34645 7.38089 8.30522C7.34987 8.26398 7.33338 8.21679 7.33317 8.16867V3.83133C7.33328 3.7831 7.34974 3.73579 7.3808 3.69445C7.41186 3.65311 7.45635 3.61929 7.50954 3.59657C7.56273 3.57386 7.62262 3.56312 7.68284 3.56548C7.74306 3.56784 7.80135 3.58323 7.8515 3.61Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessons);
export default __webpack_public_path__ + "static/media/lessons.44e994a6afe031ec1eb6c2e2d62978b3.svg";
export { ForwardRef as ReactComponent };